<div *ngIf="modalIsVisible2" class="modal-overlay">

    <form class="modal" [formGroup]="profileForm" novalidate>
        <div class="close-btn"><span
            class="my-color-blue">{{ '__AVAIL_ADD_YOUR_TIME__' | translate }}</span><img
                (click)="closeAddYourTimeModal()" src="assets/img/close-btn.svg" /></div>
                <div class="picker-wrapp-centered">
                    <div class="picker-wrapp">
                        <ion-datetime presentation="time" minuteValues="0,5,10,15,20,25,30,35,40,45,50,55" formControlName="timePicker"
                        displayFormat="  HH:mm"  [(ngModel)]="chosenIonTime">
                        </ion-datetime>
                    </div>
                </div>
        <button class="btn-rounded-blue primary-bg-color"
                (click)="closeAddYourTimeModal(); addNewTime();"
                [ngClass]="{'disabled': !chosenIonTime}"><span>{{'__AVAIL_SAVE__' | translate}}</span></button>
    </form>
</div>
<ion-content class="content coach-calendar-wrap">
    <ion-header class="transparent absolute">
        <app-header [backRoute]="['/team']"></app-header>
    </ion-header>

    <div *ngIf="modalIsVisible" class="modal-overlay">
        <form class="modal">
            <div class="close-btn">
                <span class="my-color-blue">{{'__AVAIL_CHECK_YOUR_TIME__' | translate}} {{ selectedDate | amDateFormat: 'Do MMMM, y' }}</span><img
                    (click)="closeModal()" src="assets/img/close-btn.svg"/>
            </div>
            <div class="time-container">
                <button *ngFor="let ts of currentDateEvent | filter : 'hidden' : false" class="time-schedules"
                        [ngClass]="{'choose-blue': ts.selected && !ts.disabled, 'disabled': ts.disabled && !ts.booked, 'booked': ts.booked}"
                        (click)="chosenTime(ts)">
                    {{ts.title}}
                </button>
            </div>

            <div class="ion-time-and-submit">
                <form class="time-picker" *ngIf="false" [formGroup]="profileForm" novalidate>
                    <div class="picker-container">
                        <ion-label>{{'__AVAIL_ADD_YOUR_TIME__' | translate}}</ion-label>
                        <div class="picker-wrapp-centered">
                            <div class="picker-wrapp">
                                <ion-datetime presentation="time" minuteValues="0,5,10,15,20,25,30,35,40,45,50,55" formControlName="timePicker"
                                displayFormat="  HH:mm"  [(ngModel)]="chosenIonTime">
                                </ion-datetime>
                                <div class="time-picker-ok" (click)="addNewTime()">{{'Ok' | translate}}</div>
                            </div>
                        </div>
                    </div>
                </form>

                <button class="btn-rounded-blue" (click)="onSubmit()" [disabled]="eventChangesSaved"
                        [ngClass]="{'disabled': eventChangesSaved}">
                    <span>{{'__AVAIL_SAVE__' | translate}}</span>
                </button>
            </div>


        </form>
    </div>

    <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
    </div>


    <div class="shadow-container">
        <div class="coach-head">
            <div class="availability my-color-blue">{{'__AVAIL_MY_COACH_AVAIL__' | translate}}</div>
        </div>

        <div class="month-availability">
            <div class="month">{{ viewTitle }}</div>
            <div class="availability">
                <img src="assets/img/availability-round.svg"/>
                <div>{{'__CALENDAR_AVAIL_DATES__' | translate}}</div>
            </div>
        </div>
        <div class="remember-text">

            {{'__AVAIL_REMEMBER_TEXT__' | translate}}

            <span class="remember my-color-blue">
                        {{'__AVAIL_REMEMBER_TEXT_BLUE__' | translate}}
                    </span>
        </div>

        <div class="calendar">
            <div *ngIf="!eventChangesSaved" (click)="$event.preventDefault();submitNoChanges()"
                 class="disabled-screen"></div>
            <ion-row>
                <!-- Move back one screen of the slides -->
                <ion-col size="1">
                    <ion-button fill="clear" (click)="back()" [disabled]="lockSwipeToPrev">
                        <img *ngIf="lockSwipeToPrev" src="assets/img/previous-grey.svg" alt=""/>
                        <img *ngIf="!lockSwipeToPrev" src="assets/img/previous-blue.svg" alt=""/>
                    </ion-button>
                </ion-col>

                <ion-col size="10" class="ion-text-center" *ngIf="isCalendar">
                    <calendar [eventSource]="eventSource" [calendarMode]="calendar.mode"
                              [currentDate]="calendar.currentDate"
                              (onTimeSelected)="onTimeSelected($event)"
                              (onTitleChanged)="onViewTitleChanged($event)"
                              [queryMode] = "'remote'"
                              (onRangeChanged)="onRangeChanged($event)"
                              (onCurrentDateChanged)="onCurrentDateChanged($event)"
                              [lockSwipeToPrev]="lockSwipeToPrev"
                              [lockSwipes]="lockSwipes"
                              [locale]="userService.userInfo.language.code">
                    </calendar>
                </ion-col>
                <ion-col size="10" class="calendar-skeleton-wrap ion-text-center" *ngIf="!isCalendar">
                    <div class="calendar-skeleton-row" *ngFor="let i of [0,1,2,3,4]">
                        <ion-skeleton-text animated *ngFor="let i of [0,1,2,3,4,5,6]"></ion-skeleton-text>
                    </div>
                </ion-col>

                <!-- Move forward one screen of the slides -->
                <ion-col size="1">
                    <ion-button fill="clear" (click)="next()">
                        <img src="assets/img/next-blue.svg" alt=""/>
                    </ion-button>
                </ion-col>
            </ion-row>
        </div>

        <div class="time-panel">
            <img class="clock" [src]="currentDateEventSelected ? 'assets/img/clock-blue.svg' : 'assets/img/clock-grey.svg'"/>
            <div class="time-container">
                <button *ngFor="let ts of currentDateEvent | filter : 'hidden' : false" class="time-schedules"
                        [ngClass]="{'choose-blue': ts.selected && !ts.disabled, 'disabled': ts.disabled && !ts.booked, 'booked': ts.booked }"
                        (click)="chosenTime(ts)">
                    {{ts.title}}
                </button>
                <button class="btn-round my-color-blue" *ngIf="currentDateLength() > 1"> + <span>
                                {{currentDateLength() - 1}}</span></button>
            </div>

            <img src="assets/img/arrow-down.svg" (click)="modalIsVisible = !modalIsVisible"
                 *ngIf="currentDateEvent.length !== 0"/>
        </div>

        <div class="ion-time-and-submit mobile-hide" >
            <form class="time-picker" *ngIf="false && !profileForm"></form>
            <form class="time-picker" *ngIf="false &&  profileForm" [formGroup]="profileForm" novalidate>
                <div class="picker-container">
                    <button class="add-your-time-btn" (click)="openAddYourTimeModal()">
                        {{'__AVAIL_ADD_YOUR_TIME__' | translate}}
                    </button>
                    <!-- <div class="picker-wrapp">
                        <ion-datetime presentation="time" minuteValues="0,5,10,15,20,25,30,35,40,45,50,55" formControlName="timePicker"
                        displayFormat="  HH:mm"  [(ngModel)]="chosenIonTime">
                        </ion-datetime>
                        <div class="time-picker-ok" (click)="addNewTime()">{{'Ok' | translate}}</div>
                    </div> -->
                </div>
            </form>
            <div class="time-picker"></div>
            <button class="calendar-confirm-btn" (click)="onSubmit()" [disabled]="eventChangesSaved"
                    [ngClass]="{'disabled': eventChangesSaved}">
                <img src="assets/icon/calendar-confirm-icon.svg">
                <span>{{'__CALENDAR_CONFIRM_SELECTION__' | translate}}</span>
            </button>
        </div>
    </div>
    <app-footer-logo></app-footer-logo>
</ion-content>
